import React from 'react';
import { Scale, Users, Building2, Briefcase, Globe, GraduationCap } from 'lucide-react';

const practiceAreas = [
    {
        icon: <Users className="w-12 h-12" />,
        title: 'Family Law',
        description: 'Compassionate guidance through family matters and disputes.',
        bgColor: 'bg-blue-50',
        iconColor: 'text-blue-600',
        hoverColor: 'group-hover:bg-blue-600'
    },
    {
        icon: <Scale className="w-12 h-12" />,
        title: 'Criminal Law',
        description: 'Expert defense in criminal cases, protecting your rights and freedom.',
        bgColor: 'bg-red-50',
        iconColor: 'text-red-600',
        hoverColor: 'group-hover:bg-red-600'
    },
    {
        icon: <Building2 className="w-12 h-12" />,
        title: 'Civil Law',
        description: 'Comprehensive civil litigation and dispute resolution services.',
        bgColor: 'bg-green-50',
        iconColor: 'text-green-600',
        hoverColor: 'group-hover:bg-green-600'
    },
    {
        icon: <Briefcase className="w-12 h-12" />,
        title: 'Business Law',
        description: 'Strategic legal solutions for businesses of all sizes.',
        bgColor: 'bg-purple-50',
        iconColor: 'text-purple-600',
        hoverColor: 'group-hover:bg-purple-600'
    },
    {
        icon: <Globe className="w-12 h-12" />,
        title: 'International Law',
        description: 'Expert guidance in international legal matters and cross-border disputes.',
        bgColor: 'bg-indigo-50',
        iconColor: 'text-indigo-600',
        hoverColor: 'group-hover:bg-indigo-600'
    },
    {
        icon: <GraduationCap className="w-12 h-12" />,
        title: 'Excise and Tax',
        description: 'Protecting workers rights and handling employment disputes.',
        bgColor: 'bg-amber-50',
        iconColor: 'text-amber-600',
        hoverColor: 'group-hover:bg-amber-600'
    }
];

const PracticeAreas = () => {
    return (
        <section className="py-20 bg-gradient-to-b from-white to-gray-50">
            <div className="container mx-auto px-4">
                <div className="mb-16">
                    <div className="inline-block bg-indigo-100 text-indigo-800 px-4 py-1 rounded-md text-sm font-medium mb-4">
                        LEGAL EXPERTISE
                    </div>
                    <h2 className="text-4xl font-bold mb-4">Our Practice Areas</h2>
                    <p className="text-gray-600 max-w-2xl">
                        We provide comprehensive legal services across multiple practice areas, 
                        ensuring expert representation for all your legal needs.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {practiceAreas.map((area, index) => (
                        <div 
                            key={index}
                            className="group relative bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden cursor-pointer"
                        >
                            <div className="absolute top-0 left-0 h-full w-1 bg-gray-200 transition-all duration-300 ease-in-out group-hover:w-full group-hover:bg-opacity-10 z-0"></div>
                            <div className={`absolute top-0 left-0 h-1 w-0 ${area.hoverColor} transition-all duration-500 ease-in-out group-hover:w-full z-10`}></div>
                            
                            <div className="p-8 relative z-10">
                                <div className={`${area.bgColor} ${area.iconColor} p-4 inline-flex rounded-lg mb-6 transition-colors duration-300`}>
                                    {area.icon}
                                </div>
                                <h3 className="text-xl font-bold mb-3 group-hover:text-indigo-700 transition-colors">{area.title}</h3>
                                <p className="text-gray-600">{area.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PracticeAreas;